import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, StickyNote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { API } from "@/utils/constants";

export const AddNoteDialog = ({ open, onClose, onCreated, authPassword }) => {
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !startDate) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/notes`, {
        title: title.trim(),
        start_date: startDate,
        end_date: endDate || startDate,
      }, { headers: { "X-Auth-Password": authPassword } });
      toast.success("Note added to rota");
      setTitle("");
      setStartDate("");
      setEndDate("");
      onCreated();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to add note");
    }
    setSubmitting(false);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#2d2d2d]">
            <StickyNote className="h-5 w-5" />
            Add Rota Note
          </DialogTitle>
          <DialogDescription>
            Add a non-job item that shows on the rota (e.g. work experience, training)
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-xs font-medium text-gray-500">Title</Label>
            <Input
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder="e.g. Work Experience - Hannah"
              required
              autoFocus
              data-testid="note-title"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs font-medium text-gray-500">Start Date</Label>
              <Input
                type="date"
                value={startDate}
                onChange={e => { setStartDate(e.target.value); if (!endDate) setEndDate(e.target.value); }}
                required
                data-testid="note-start-date"
              />
            </div>
            <div>
              <Label className="text-xs font-medium text-gray-500">End Date</Label>
              <Input
                type="date"
                value={endDate}
                onChange={e => setEndDate(e.target.value)}
                min={startDate}
                data-testid="note-end-date"
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button
              type="submit"
              disabled={!title.trim() || !startDate || submitting}
              className="bg-[#605e5e] hover:bg-[#4b4a4a] text-white"
              data-testid="note-submit-btn"
            >
              {submitting ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <StickyNote className="h-4 w-4 mr-2" />}
              Add Note
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
